/* 
Allows the connected wallet to withdraw accrued Eth fees
*/
import { Stack, Text, Button } from "@mantine/core";
import { useBondingManager } from "../../../hooks/WithSmartContracts";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import SmartContractAction from "../components/SmartContractAction";

export default function WithdrawFees(props) {
  const [withdrawnEth, setWithdrawn] = useState(0);
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [thisErrMsg, setErrMsg] = useState("");
  const bondingManager = useBondingManager();

  const withdrawFees = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        setIsPending(true);
        const txn = await bondingManager.withdrawFees(
          props.connectedWallet,
          props.pendingEth
        );
        setTxn(txn.hash);
        await txn.wait();
        setWithdrawn(props.pendingEth);
        props.refreshWallet();
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setWithdrawn(0);
      setTxn("");
      setIsPending(false);
    }
  };

  if (!props.pendingEth && !withdrawnEth || props.pendingEth == 0) {
    return (
      <Stack spacing={24}>
        <Button
          radius="xs"
          uppercase
          disabled
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
          styles={(theme) => ({
            label: {
              color: "#afb0b3",
            },
          })}
        >
          No Eth available for withdrawal...
        </Button>
      </Stack>
    );
  } else {
    return (
      <Stack spacing={24}>
        <SmartContractAction
          isPending={isPending}
          txn={thisTxn}
          thisErrMsg={thisErrMsg}
          isFinished={withdrawnEth > 0 ? true : false}
          action={withdrawFees}
          actionMessage={
            "Withdraw " +
            (props.pendingEth / ethers.constants.WeiPerEther).toFixed(4) +
            " Eth"
          }
          finishedMessage={
            "Successfully withdrew " +
            (withdrawnEth / ethers.constants.WeiPerEther).toFixed(4) +
            " Eth!"
          }
          pendingMessage={"Withdrawing Eth..."}
        />
        {thisErrMsg != "" ? (
          <Text size="xl" fw={700}>
            The previous transaction failed with reason `{thisErrMsg}`
          </Text>
        ) : null}
      </Stack>
    );
  }
}
